import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { ToastContainer, toast } from 'react-toastify';
import { UpdateBill, ViewBill } from "../../ImprestExpenseManagement/ExpenseSheet/ExpenseSlipComponents";
import { AddwithBlueCircle, Attachment, BlueEye, CrosswithGreyCircle, DeleteDustbin } from "../../AllSvg";
import { formatCurrencyIndian, formatRoundoff2D, handleErrorToast } from "../../CustomFunctions";
import { SingleMonthYearSelect } from "../../CustomFilters";

const ExpenseDetailDelete = ({
  id,
  getExpenses,
  date,
  getSpecificExpenses,
}) => {
  const [show, setShow] = useState(false);

  // console.log(id)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (item_name) => {
    item_name.preventDefault();

    try {
      console.log("Delete Expense Detail Api");
      let res = await axios.delete(
        `${BASE_URL}/wfm/expensedetailsdelete/${id.id}/`
      );

      if (res.status === 200) {
        await getExpenses(date);
        getSpecificExpenses();
        setShow(false);
      } else {
        console.error(res);
      }
    } catch (err) {
      handleErrorToast(err);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleFormSubmitDelete}>
        <DeleteDustbin />
      </button>

      {/* <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          
            <div className="button-models">
              
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
         
        </Modal.Body>
      </Modal> */}
    </>
  );
};

const ExpenseDetailsAdd = ({ i, totall, expansee, status, utilize, remain }) => {
  // ***********Model Code Api Start ***********

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setFormData({
      item_name: "",
      expense_type: "",
      item_amount: "",
      bill: "",
    })
    setErrors({});
    setShow(false)
  };
  const handleShow = () => {
    setShow(true);
    getExpenses(formdate);
    getSpecificExpenses();
  };

  // **********Table Visibility Api Start ***********

  const [showAdd, setShowAdd] = useState(false);
  const handleClosee = () => {
    setFormData({
      item_name: "",
      expense_type: "",
      item_amount: "",
      bill: "",
    });
    handleClear();
    setErrors({});
    setShowAdd(false)
  };
  const handleShoww = () => setShowAdd(true);

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const formatttedDatee = `${day.toString().padStart(2, "0")}`;
  console.log(formatttedDatee, "formatttedDatee");

  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  console.log(formattedDate, "formattedDate");


  const [monthh, setMonthh] = useState(`${month}`);

  const formatedmonth = `${monthh.toString().padStart(2, "0")}`;
  const [yearr, setYearr] = useState(`${year}`);
  console.log(monthh, "monthh");
  console.log(yearr, "yearr");
  console.log(formatedmonth, "formatedmonth");

  const getAllDatessOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      console.log(formatttedDatee, "formatttedDatee inside getAllDatessOfMonth");

      datees.push({ date: formatttedDatee });
    }

    return datees;
  };

  const datees = getAllDatessOfMonth(monthh, yearr); // get all dates for March 2023
  console.log(datees, "datees");

  const [selecteddate, setSelecteddate] = useState(`${formatttedDatee}`);

  const handleselectvalue = (date) => {
    console.log(date, "date inside handleselectvalue");

    setSelecteddate(date);
    const formatdate = `${yearr}-${monthh}-${date}`;
    getExpenses(formatdate);
  };

  const formdate = `${yearr}-${monthh}-${selecteddate}`;
  console.log(formdate, "formdate");

  // ! **********Expense Detail by Id Get Api Start ***********

  const [updatedlist, setUpdatedList] = useState([]);
  const [expenseMonthSet, setExpenseMonthSet] = useState(new Set());

  const [sum, setSum] = useState(0);
  const [appsum, setAppSum] = useState(0);

  const getSpecificExpenses = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/expensedetailsbyexpense/${i.id}/`
      );

      const summ = res.data.reduce(
        (acc, item) => acc + parseFloat(item.item_amount),
        0
      );
      const appsumm = res.data.reduce(
        (acc, item) => acc + parseFloat(item.bill_approved_amt),
        0
      );
      setSum(summ);
      setAppSum(appsumm);
      const uniqueMonthSet = new Set();
      const uniqueDatesSet = new Set();
      res.data.forEach((item) => {
        const [y, m] = item.date.split("-");
        uniqueMonthSet.add(`${y}-${m}`);
        uniqueDatesSet.add(item.date);
      });

      setExpenseMonthSet(uniqueMonthSet);
      setUpdatedList(Array.from(uniqueDatesSet));
    } catch (err) { }
  };

  // ! **********Expense Detail by Date Get Api Start ***********

  const [expensenames, setExpensenames] = useState([]);
  const getExpenses = async (formdate) => {
    console.log(formdate, "formdate inside getExpense");

    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/expensedetailsbydate/${formdate}/${i.id}/`
      );
      setExpensenames(res.data);
    } catch (err) { }
  };

  // ! **********Expense Detail Add Api Start ***********

  const [formData, setFormData] = useState({
    item_name: "",
    expense_type: "",
    item_amount: "",
    bill: "",
  });

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["item_name", "item_amount", "expense_type", "bill"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    // NEW: Check if amount is 0 or negative
    if (formData.item_amount && parseFloat(formData.item_amount) <= 0) {
      newErrors.item_amount = "Amount must be greater than 0";
    } 

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setInputState({

  //     ...inputState,
  //     [name]: value.trim() ? "green" : "",
  //   });

  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "expense_type") {
      let maxAmount = 0;

      // Set max value based on selected expense_type
      switch (value) {
        case "transportation":
          maxAmount = i.approved_transportation;
          break;
        case "accomodation":
          maxAmount = i.approved_accomodation;
          break;
        case "fooding":
          maxAmount = i.approved_fooding;
          break;
        default:
          // For "other" details
          const selectedOther = i.other_details?.find(other => other.other_name === value);
          if (selectedOther) {
            maxAmount = selectedOther.approved_other;
          }
          break;
      }

      setFormData({
        ...formData,
        [name]: value,  // Update the selected expense_type
        max_amount: maxAmount,  // Store the max value based on the selected type
      });
    } else if (name === "item_amount") {
      const maxAmount = formData.max_amount || 0;
      const numericValue = parseFloat(value);

      // Always allow the user to input any value, just provide feedback if it's too high
      setInputState({
        ...inputState,
        [name]: value.trim() ? "success" : "",
      });

      setFormData({
        ...formData,
        [name]: value,
      });

      // if (parseFloat(value) > maxAmount) {
      //   setErrors({
      //     ...errors,
      //     [name]: `Amount should be ≤ ${maxAmount} (imprest limit)`,
      //   });
      // } else {
      //   setErrors({
      //     ...errors,
      //     [name]: "",
      //   });
      // }

      // ADDED CONDITION: Only check for maxAmount if it is greater than 0 (meaning there is an imprest limit)
      if (value.trim() !== "" && numericValue <= 0) {
        setErrors({
          ...errors,
          [name]: "Amount must be greater than 0",
        });
      } 
      else if (maxAmount > 0 && numericValue > maxAmount) {
        setErrors({
          ...errors,
          [name]: `Amount should be ≤ ${maxAmount} (imprest limit)`,
        });
      } 
      else {
        setErrors({
          ...errors,
          [name]: "",
        });
      }

    } else {
      setInputState({
        ...inputState,
        [name]: value.trim() ? "success" : "",
      });

      setFormData({
        ...formData,
        [name]: value,
      });
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };


  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "expense_type") {
  //     let maxAmount = 0;

  //     // Set max value based on selected expense_type
  //     switch (value) {
  //       case "transportation":
  //         maxAmount = i.approved_transportation;
  //         break;
  //       case "accomodation":
  //         maxAmount = i.approved_accomodation;
  //         break;
  //       case "fooding":
  //         maxAmount = i.approved_fooding;
  //         break;
  //       default:
  //         // For "other" details
  //         const selectedOther = i.other_details?.find(other => other.other_name === value);
  //         if (selectedOther) {
  //           maxAmount = selectedOther.approved_other;
  //         }
  //         break;
  //     }

  //     setFormData({
  //       ...formData,
  //       [name]: value,  // Update the selected expense_type
  //       max_amount: maxAmount,  // Store the max value based on the selected type
  //     });
  //   } else if (name === "item_amount") {
  //     // Check if the value is less than or equal to the max amount
  //     const maxAmount = formData.max_amount || 0;

  //     if (parseFloat(value) <= maxAmount) {
  //       setInputState({
  //         ...inputState,
  //         [name]: value.trim() ? "success" : "",
  //       });

  //       setFormData({
  //         ...formData,
  //         [name]: value,
  //       });

  //       setErrors({
  //         ...errors,
  //         [name]: "",
  //       });
  //     } else {
  //       // Handle case where the input value exceeds the allowed max amount
  //       setErrors({
  //         ...errors,
  //         [name]: `Amount must be less than or equal to ${maxAmount}`,
  //       });
  //     }
  //   } else {
  //     // For textarea or other fields without validation
  //     setInputState({
  //       ...inputState,
  //       [name]: value.trim() ? "success" : "",
  //     });

  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //     setErrors({
  //       ...errors,
  //       [name]: "",
  //     });
  //   }
  // };


  const [fileName, setFileName] = useState("");
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (file) {
      setFormData({ ...formData, [name]: file, });
      setFileName(file.name);
    } else {
      setFileName("");
    }
  };

  const handleClear = () => {
    setFormData(prevState => ({
      ...prevState,
      bill: ""
    }));
    setFileName("");
  }

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleExpenseSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formDataa = new FormData();
      formDataa.append("item_name", formData.item_name);
      formDataa.append("item_amount", formData.item_amount);
      formDataa.append("expense_type", formData.expense_type);
      formDataa.append("date", `${yearr}-${monthh}-${selecteddate}`);


      const symbols = '!@#$%^&*()_-+=';
      const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
      const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const numbers = '0123456789';
      const now = new Date();
      const date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
      const time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = '';
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const originalFile = formData.bill;
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
      const customFile = new File([originalFile], customFileName, { type: originalFile.type });
      formDataa.append("bill", customFile);
      formDataa.append("expense", i.id);

      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/expensedetailsadd/`,
          formDataa,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (res.status === 200) {
          await getExpenses(formdate);
          await getSpecificExpenses();
          await handleClosee();
          // setShow(false);
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="text-button allproject-dashboard" title={`Amount:-\nUtilized: ${formatRoundoff2D(utilize !== null ? utilize : sum)} \nRemaining: ${formatRoundoff2D(remain !== null ? remain : Number(totall) - Number(sum))} `} onClick={handleShow}>
        {/* <AddwithBlueCircle /> */}
        {i.submit_for_approval === false || i.partially_change === true ?
          <>
            <AddwithBlueCircle /> Update Bills
          </>
          : <>
            <BlueEye />View Bills
          </>
        }
      </button>

      {/* <Modal show={show} onHide={handleClose} dialogClassName="half-modal width-50vw"> */}
      <Modal show={show} dialogClassName="three-fourth-modal width-50vw">
        {/* <Modal.Header closeButton>
          <Modal.Title>Request Leave</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="bdy-div">

              <div className="flex-row justify-between w-full" >
                <h6 className="task-Tab-heading   font-weight500    font-size-heading">Expense Details: </h6>
                {/* <SingleMonthYearSelect
                  value={monthh && yearr ? `${yearr}-${String(monthh).padStart(2, "0")}` : null}
                  placeholder="Select Month"
                  onChange={(value) => {
                    if (value) {
                      const [year, month] = value.split("-");
                      setYearr(year);
                      setMonthh(month.replace(/^0+/, ""));
                    } else {
                      setYearr("");
                      setMonthh("");
                    }
                  }}
                  style={{ width: "10vw" }}
                /> */}
                <SingleMonthYearSelect
                  value={
                    monthh && yearr
                      ? `${yearr}-${String(monthh).padStart(2, "0")}`
                      : null
                  }
                  placeholder="Select Month"
                  onChange={(val) => {
                    if (!val) {
                      setYearr("");
                      setMonthh("");
                      return;
                    }

                    const [year, month] = val.split("-");
                    setYearr(year);
                    setMonthh(month.replace(/^0+/, ""));
                  }}
                  selectedMonthSet={expenseMonthSet}
                // style={{ width: "10vw" }}
                />
              </div>

              {/* <div className="flex-row" style={{ justifyContent: "center" }}>
                <div>
                  <select
                    className="attendance-input-field width-10vw   date-field"
                    type="text"
                    value={monthh}
                    onChange={(e) => setMonthh(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div>
                  <input
                    type="number"
                    maxLength={4}
                    value={yearr}
                    onChange={(e) => setYearr(e.target.value)}
                    className="attendance-input-field width-5vw   date-field"
                  />
                </div>
              </div> */}


              {/* <input
                type="month"
                className="attendance-input-field width-10vw date-field expense-month-picker"
                value={
                  monthh && yearr
                    ? `${yearr}-${String(monthh).padStart(2, "0")}`
                    : ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setYearr(year);
                    setMonthh(month.replace(/^0+/, ""));
                  } else {
                    setYearr("");
                    setMonthh("");
                  }
                }}
              /> */}

              <hr className="line" />

              <div className="expense-circle-outer">
                <div className="expense-circle-outer">
                  {datees.map((data) => {
                    const date = `${yearr}-${formatedmonth}-${data.date}`;
                    const selectedformatdate = `${yearr}-${formatedmonth}-${selecteddate}`;
                    return (
                      <button
                        className={`expsense-circle ${date === formattedDate
                          ? "expsense-circle-today"
                          : date === selectedformatdate
                            ? "expsense-circle-selected"
                            : updatedlist?.includes(date)
                              ? "expsense-circle-used"
                              : "expsense-circle-general"
                          }`}
                        key={data.date}
                        onClick={() => handleselectvalue(data.date)}
                      >
                        {data.date}
                      </button>
                    );
                  })}
                </div>
                <hr className="line" />
                <div className="amount-status">
                  <div className="align-center">
                    <div className="flex-row">
                      <div>
                        <h6 className="utilize   font-weight500    font-size-text ">Spent Amount</h6>
                        <p className="utilize font-weight500 align-center" style={{ color: "red" }}>
                          {formatRoundoff2D(sum)}
                        </p>
                      </div>
                      <div>
                        <hr className="field-cont-hr" />
                      </div>
                      <div>
                        <h6 className="utilize   font-weight500    font-size-text ">Approved Amount</h6>
                        <p className="utilize font-weight500 align-center" style={{ color: "red" }}>
                          {appsum ? formatRoundoff2D(appsum) : '-'}
                        </p>
                      </div>
                    </div>
                    <h6 className="utilize   font-weight500    font-size-text">Utilize</h6>
                  </div>
                  <div className="align-center">
                    <div className="flex-row">
                      <div>
                        <h6 className="remaining  font-weight500    font-size-text ">After Spent</h6>
                        <p className=" remaining font-weight500 align-center" style={{ color: "#2576bc" }}>
                          {formatRoundoff2D(Number(totall) - Number(sum))}
                        </p>
                      </div>
                      <div>
                        <hr className="field-cont-hr" />
                      </div>
                      <div>
                        <h6 className="utilize   font-weight500  font-size-text ">After Approval</h6>
                        <p className=" utilize font-weight500 align-center" style={{ color: "#2576bc" }}>
                          {appsum ? formatRoundoff2D(Number(totall) - Number(appsum)) : '-'}
                        </p>
                      </div>
                    </div>
                    <h6 className="remaining  font-weight500 font-size-text ">Remaining</h6>
                  </div>
                </div>
                <hr className="line" />
                {/* 
                <table className="table-css">
                  <thead>
                    <tr className="custom-table-head-tr">
                      <th className="align-left">S. No.</th>
                      <th className="align-center">Item</th>
                      <th className="align-center">Type</th>
                      <th className="align-center">Amount</th>
                      <th className="align-center">Attached Bill</th>
                      <th className="align-center">Approved Amount</th>
                      <th className="align-right width-5vw">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expensenames.map((j, index) => (
                      <React.Fragment key={index}>
                        <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr>
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">{j.item_name}</td>
                          <td className="align-center text-capitalize">
                            {j.expense_type ? j.expense_type : "-"}
                          </td>
                          <td className="align-center" title={`TL Approved Amount:${j.tl_approved_amt}`}>{j.item_amount}</td>
                          <td className="align-center">
                            {j.bill ? (
                              i.partially_change ? <>
                                Last Submitted:<ViewBill i={j} />
                              </> :
                                <>
                                  <ViewBill i={j} />
                                </>
                            ) : (
                              "Bill Not Attached"
                            )}
                          </td>
                          <td className="align-center"> {
                            j.bill_approved_amt === "0" && j.bill_approved === "rejected" ?
                              <span title={`${j.bill_amount_change_reason ? `Amount Change Reason: \n${j.bill_amount_change_reason}\n` : ""}${j.bill_approved === "rejected" ? `Bill Reject Reason: \n${j.bill_rejection_reason}` : ""}`} style={{ textDecoration: 'line-through' }}>{j.tl_approved_amt}</span>
                              : j.bill_approved_amt
                          }</td>
                         
                          <td className="align-center width-5vw">
                            {
                              i.submit_for_approval ? (
                                i.partially_change && j.bill_approved === "rejected" && j.tl_approved_amt !== "0" ?
                                  <>Bill:<span request-status={j.bill_approved} className="request-status align-center text-capitalize">
                                    {j.bill_approved}</span>
                                    <br />
                                    Upload New:
                                    <UpdateBill
                                      i={j}
                                      date={formdate}
                                      getSpecificExpenses={getSpecificExpenses}
                                      getExpenses={getExpenses}
                                    />
                                  </>
                                  :
                                  <>Bill Check:<span request-status={j.bill_approved} className="request-status align-center text-capitalize">
                                    <br />{j.bill_approved}</span>
                                  </>
                              ) : (
                                <>
                                  <ExpenseDetailDelete
                                    id={j}
                                    getExpenses={getExpenses}
                                    date={formdate}
                                    getSpecificExpenses={getSpecificExpenses}
                                  />
                                  <br />
                                  Bill:<span request-status={j.bill_approved} className="request-status align-center text-capitalize">
                                    {j.bill_approved}</span>
                                </>
                              )
                            }
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table> */}
                <div className="expense-table-wrapper">
                  <div className="expense-table-header">
                    <div>
                      <h5 className="expense-table-title">Expense Entries</h5>
                      <p className="expense-table-subtitle">
                        View and manage submitted expense bills.
                      </p>
                    </div>

                    <div className="expense-summary-badge">
                      Total Entries: {expensenames?.length || 0}
                    </div>
                  </div>

                  <div className="expense-table-scroll">
                    <table className="table-css modern-expense-table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Item</th>
                          <th>Type</th>
                          <th>Amount</th>
                          <th>Attached Bill</th>
                          <th>Approved Amount</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {expensenames?.length > 0 ? (
                          expensenames.map((j, index) => (
                            <tr key={index} className="expense-row">
                              <td>
                                <div>{index + 1}.</div>
                              </td>

                              <td style={{ fontSize: '14px' }} className="font-weight500">
                                {j.item_name}
                                {/* <div className="expense-item-name"></div> */}
                              </td>

                              <td>
                                <span className="expense-type-badge text-capitalize">
                                  {j.expense_type || '-'}
                                </span>
                              </td>

                              <td>
                                <div
                                  style={{ fontSize: '14px' }} className="font-weight500"
                                  title={`TL Approved Amount: ${j.tl_approved_amt}`}
                                >
                                  {j.item_amount}
                                </div>
                              </td>

                              <td>
                                <div className="bill-view-wrapper">
                                  {j.bill ? (
                                    i.partially_change ? (
                                      <>
                                        <span className="last-submitted-text">
                                          Last Submitted :
                                        </span>
                                        <ViewBill i={j} />
                                      </>
                                    ) : (
                                      <ViewBill i={j} />
                                    )
                                  ) : (
                                    <span className="no-bill-text">Bill Not Attached</span>
                                  )}
                                </div>
                              </td>

                              <td>
                                {j.bill_approved_amt === '0' &&
                                  j.bill_approved === 'rejected' ? (
                                  <span
                                    title={`${j.bill_amount_change_reason
                                      ? `Amount Change Reason:\n${j.bill_amount_change_reason}\n`
                                      : ''
                                      }${j.bill_approved === 'rejected'
                                        ? `Bill Reject Reason:\n${j.bill_rejection_reason}`
                                        : ''
                                      }`}
                                    style={{ textDecoration: 'line-through' }}
                                  // className="rejected-amount"
                                  >
                                    {j.tl_approved_amt}
                                  </span>
                                ) : (
                                  <span >
                                    {j.bill_approved_amt}
                                  </span>
                                )}
                              </td>

                              <td className="align-center width-5vw">

                                {i.submit_for_approval ? (
                                  i.partially_change &&
                                    j.bill_approved === 'rejected' &&
                                    j.tl_approved_amt !== '0' ? (
                                    <>
                                      <span
                                        request-status={j.bill_approved}
                                        className="request-status align-center text-capitalize"
                                      >
                                        {j.bill_approved}
                                      </span>

                                      <div className="mt-1">
                                        <UpdateBill
                                          i={j}
                                          date={formdate}
                                          getSpecificExpenses={getSpecificExpenses}
                                          getExpenses={getExpenses}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <span
                                      request-status={j.bill_approved}
                                      className="request-status align-center text-capitalize"
                                    >
                                      {j.bill_approved}
                                    </span>
                                  )
                                ) : (
                                  <>
                                    <ExpenseDetailDelete
                                      id={j}
                                      getExpenses={getExpenses}
                                      date={formdate}
                                      getSpecificExpenses={getSpecificExpenses}
                                    />
                                    <br />
                                    <span style={{ fontSize: '13px' }}>Bill:</span>
                                    <span
                                      style={{ fontSize: '13px' }}
                                      request-status={j.bill_approved}
                                      className="request-status align-center text-capitalize"
                                    >
                                      {j.bill_approved}
                                    </span>
                                  </>
                                )}

                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7">
                              <div className="empty-expense-state">
                                <h6>No Expense Added</h6>
                                <p>
                                  No expense entries available for the selected date.
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* {i.submit_for_approval ? null : showAdd === true ? (
                <>
                  <div className="expense-req">
                    <div className="flex-column">
                      <label
                        htmlFor="item_name"
                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                      >
                        Item<span className="required">*</span>
                      </label>
                      <input
                        id="item_name"
                        type="text"
                        name="item_name"
                        placeholder="Item"
                        onChange={handleInputChange}
                        value={formData.item_name}
                        className={`form-inputs ${errors.item_name
                          ? "error"
                          : inputState.item_name
                            ? "success"
                            : ""
                          }`}
                      />
                      {errors.item_name && (
                        <span className="error-message font-size-text ">{errors.item_name}</span>
                      )}
                    </div>

                    <div className="flex-column">
                      <label
                        htmlFor="expense_type"
                        className="form-labels  font-weight500    announce-date font-size-heading"
                      >
                        Type<span className="required">*</span>
                      </label>

                      <select
                        id="expense_type"
                        name="expense_type"
                        // className="attendance-input-field width-5vw   date-field"
                        // type="text"
                        value={formData.expense_type}
                        onChange={handleInputChange}
                        className={` form-inputs ${errors.expense_type
                          ? "error"
                          : inputState.expense_type
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="">Type</option>
                        {i.approved_transportation > 0 && <option value="transportation">Transportation</option>}
                        {i.approved_accomodation > 0 && <option value="accomodation">Accomodation</option>}
                        {i.approved_fooding > 0 && <option value="fooding">Food</option>}
                        {i.other_details?.length > 0
                          ?
                          i.other_details?.map((other, index) => (
                            <option key={index} value={`${other.other_name}`} className='text-capitalize'>{other.other_name}</option>
                          ))
                          : null
                        }
                      </select>
                      {errors.expense_type && (
                        <span className="error-message font-size-text ">{errors.expense_type}</span>
                      )}
                    </div>

                    <div className="flex-column">
                      <label
                        htmlFor="item_amount"
                        className="form-labels justify-center font-weight500 announce-date font-weight400  font-size-heading"
                      >
                        Amount<span className="required">*</span>
                      </label>
                      <input
                        id="item_amount"
                        min={0}
                        title={
                          formData.expense_type === "transportation"
                            ? `Max amount for transportation is ${i.approved_transportation}`
                            : formData.expense_type === "accomodation"
                              ? `Max amount for accommodation is ${i.approved_accomodation}`
                              : formData.expense_type === "fooding"
                                ? `Max amount for fooding is ${i.approved_fooding}`
                                : `Max amount for ${formData.expense_type} is ${i.other_details?.find(other => other.other_name === formData.expense_type)?.approved_other || 0}`
                        }
                        max={
                          formData.expense_type === "transportation"
                            ? i.approved_transportation
                            : formData.expense_type === "accomodation"
                              ? i.approved_accomodation
                              : formData.expense_type === "fooding"
                                ? i.approved_fooding
                                : i.other_details?.find(other => other.other_name === formData.expense_type)?.approved_other || 0
                        }
                        type="number"
                        name="item_amount"
                        placeholder="Amount"
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange}
                        value={formData.item_amount}
                        className={`form-inputs ${errors.item_amount
                          ? "error"
                          : inputState.item_amount
                            ? "success"
                            : ""
                          }`}
                      />
                      {errors.item_amount && (
                        <span className="error-message font-size-text ">
                          {errors.item_amount}
                        </span>
                      )}
                    </div>

                    <div className="flex-column">
                      <label
                        htmlFor="bill"
                        // className="form-labels announce-date font-weight500  form-inputss"
                        className="form-labels   font-weight500    announce-date font-size-heading"
                        style={{ width: '8vw' }}
                      >
                        Attach Bill<span className="required">*</span>
                      </label>
                      <label
                        title={`${fileName && `${fileName}`}`}
                        htmlFor="file-upload"
                        className={`custom-doc-upload ${errors.bill
                          ? "error"
                          : inputState.bill
                            ? "success"
                            : ""
                          }`}
                      >
                        <div htmlFor="file-upload" className="">
                          <div className={`align-center pdf-input  ${errors.bill ? 'error' : ''}`}>
                            <Attachment />
                          </div>
                        </div>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        name="bill"
                        onChange={handleFileChange}
                        style={{ display: "none", position: "relative" }}
                        className="width-5vw"
                      />
                      <div className="flex-row justify-evenly">
                        <div>
                          <br />
                          {fileName && <p className="width-10vw">{fileName}</p>}
                        </div>
                      </div>
                      {errors.bill && (
                        <span className="error-message font-size-text ">{errors.bill}</span>
                      )}
                    </div>


                    <div className="flex-column">
                      <label
                        htmlFor="bill"
                        className="announce-date font-weight400  form-inputss"
                      ></label>
                      <div className="flex-row action-div">
                        <button className=""
                          onClick={() => {
                            handleClosee();
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                              stroke="#707070"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M15 9L9 15"
                              stroke="#707070"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9 9L15 15"
                              stroke="#707070"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          className="form-inputs-submit width-5vw"
                          onClick={handleExpenseSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div>
                  <button
                    title="Add Expense Details"
                    onClick={handleShoww}
                    className="jd-heading-main font-weight600 -right-button"
                    style={{ float: "right" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_450_2151)">
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                          fill="#2576BC"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_450_2151">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  <br />
                </div>
              )} */}

              {i.submit_for_approval ? null : showAdd === true ? (
                <div className="modern-expense-form-card">

                  <div className="expense-form-header">
                    <div>
                      <h5 className="expense-form-title">Add Expense</h5>
                      <p className="expense-form-subtitle">
                        Fill expense details and upload bill.
                      </p>
                    </div>

                    <button
                      className="expense-close-btn"
                      onClick={() => {
                        handleClosee();
                      }}
                    >
                      <CrosswithGreyCircle />
                    </button>
                  </div>

                  <div className="expense-form-grid">

                    {/* ITEM */}
                    <div className="modern-form-group">
                      <label htmlFor="item_name" className="modern-form-label">
                        Item Name<span className="required">*</span>
                      </label>

                      <input
                        id="item_name"
                        type="text"
                        name="item_name"
                        placeholder="Enter Item Name"
                        onChange={handleInputChange}
                        value={formData.item_name}
                        className={`modern-form-input ${errors.item_name
                          ? "error"
                          : inputState.item_name
                            ? "success"
                            : ""
                          }`}
                      />

                      {errors.item_name && (
                        <span className="error-message font-size-text mt-2">
                          {errors.item_name}
                        </span>
                      )}
                    </div>

                    {/* TYPE */}
                    <div className="modern-form-group">
                      <label htmlFor="expense_type" className="modern-form-label">
                        Expense Type<span className="required">*</span>
                      </label>

                      <select
                        id="expense_type"
                        name="expense_type"
                        value={formData.expense_type}
                        onChange={handleInputChange}
                        className={`modern-form-input ${errors.expense_type
                          ? "error"
                          : inputState.expense_type
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="">Select Type</option>

                        {i.approved_transportation > 0 && (
                          <option value="transportation">
                            Transportation
                          </option>
                        )}

                        {i.approved_accomodation > 0 && (
                          <option value="accomodation">
                            Accommodation
                          </option>
                        )}

                        {i.approved_fooding > 0 && (
                          <option value="fooding">
                            Food
                          </option>
                        )}

                        {i.other_details?.length > 0
                          ? i.other_details?.map((other, index) => (
                            <option
                              key={index}
                              value={`${other.other_name}`}
                              className="text-capitalize"
                            >
                              {other.other_name}
                            </option>
                          ))
                          : null}
                      </select>

                      {errors.expense_type && (
                        <span className="error-message font-size-text mt-2">
                          {errors.expense_type}
                        </span>
                      )}
                    </div>

                    {/* AMOUNT */}
                    <div className="modern-form-group">
                      <label htmlFor="item_amount" className="modern-form-label">
                        Amount<span className="required">*</span>
                      </label>

                      <input
                        id="item_amount"
                        min={0}
                        // title={
                        //   formData.expense_type === "transportation"
                        //     ? `Max amount for transportation is ${i.approved_transportation}`
                        //     : formData.expense_type === "accomodation"
                        //       ? `Max amount for accommodation is ${i.approved_accomodation}`
                        //       : formData.expense_type === "fooding"
                        //         ? `Max amount for fooding is ${i.approved_fooding}`
                        //         : `Max amount for ${formData.expense_type} is ${i.other_details?.find(
                        //           (other) =>
                        //             other.other_name === formData.expense_type
                        //         )?.approved_other || 0
                        //         }`
                        // }
                        title={
                          formData.max_amount > 0 
                            ? `Max amount for ${formData.expense_type} is ${formData.max_amount}` 
                            : "No imprest limit"
                        }
                        // max={
                        //   formData.expense_type === "transportation"
                        //     ? i.approved_transportation
                        //     : formData.expense_type === "accomodation"
                        //       ? i.approved_accomodation
                        //       : formData.expense_type === "fooding"
                        //         ? i.approved_fooding
                        //         : i.other_details?.find(
                        //           (other) =>
                        //             other.other_name === formData.expense_type
                        //         )?.approved_other || 0
                        // }
                        max={formData.max_amount > 0 ? formData.max_amount : undefined}
                        type="number"
                        name="item_amount"
                        placeholder="Enter Amount"
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange}
                        value={formData.item_amount}
                        className={`modern-form-input ${errors.item_amount
                          ? "error"
                          : inputState.item_amount
                            ? "success"
                            : ""
                          }`}
                      />

                      {errors.item_amount && (
                        <span className="error-message font-size-text mt-2">
                          {errors.item_amount}
                        </span>
                      )}
                    </div>

                    {/* FILE */}
                    <div className="modern-form-group">
                      <label htmlFor="bill" className="modern-form-label">
                        Upload Bill<span className="required">*</span>
                      </label>

                      <label
                        htmlFor="file-upload"
                        className={`modern-upload-box ${errors.bill ? "error" : ""
                          }`}
                        title={fileName}
                      >
                        <div className="upload-inner">
                          <Attachment />

                          <div>
                            <p className="upload-title">
                              {fileName
                                ? "Bill Uploaded"
                                : "Click to Upload"}
                            </p>

                            <span className="upload-subtitle">
                              JPG, PNG, PDF
                            </span>
                          </div>
                        </div>
                      </label>

                      <input
                        id="file-upload"
                        type="file"
                        name="bill"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />

                      {fileName && (
                        <div className="uploaded-file-name">
                          {fileName}
                        </div>
                      )}

                      {errors.bill && (
                        <span className="error-message font-size-text mt-2">
                          {errors.bill}
                        </span>
                      )}
                    </div>

                  </div>

                  {/* ACTIONS */}
                  <div className="expense-form-actions">

                    <button
                      className="expense-cancel-btn"
                      onClick={() => {
                        handleClosee();
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="expense-submit-btn"
                      onClick={handleExpenseSubmit}
                    >
                      Submit Expense
                    </button>

                  </div>

                </div>
              ) : (
                <div className="add-expense-btn-wrapper">
                  <button
                    title="Add Expense Details"
                    onClick={handleShoww}
                    className="modern-add-expense-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_450_2151)">
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                          fill="white"
                        />
                      </g>

                      <defs>
                        <clipPath id="clip0_450_2151">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    Add Expense
                  </button>
                </div>
              )}

              {/* {selecteddate} */}
              <div className="button-models">
                <button className="model-button model-button-cancel   font-weight500   " onClick={handleClose}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
};

export default ExpenseDetailsAdd;
